import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';

import { CloseButton } from '@components/buttons/CloseButton';

import type { InformationModalProperties } from './InformationModal.types';

export const InformationModal: React.FC<InformationModalProperties> = ({
  dataTest = 'information_modal',
  showModal = false,
  setShowModal,
  title,
  content,
}) => {
  const handleClick = () => {
    setShowModal?.(!showModal);
  };

  return (
    <Dialog data-testid={dataTest} open={showModal}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <CloseButton onClick={handleClick} className='w-25' />
      </DialogActions>
    </Dialog>
  );
};
